"use client";

import { useEffect, useState } from "react";

import { EnvironmentConfiguration } from "@/core/EnvironmentConfiguration";

export function useAppConfiguration() {
  const [storage, setStorage] = useState();
  const [appConfigurations, setAppConfigurations] = useState({});

  useEffect(() => {
    loadConfigs();

    return () => {
      if (storage) storage.removeListener();
    };
  }, []);

  const loadConfigs = () => {
    if (storage) storage.removeListener();

    const updatedStorage = EnvironmentConfiguration.fromStorage();
    updatedStorage.addListener(() => loadConfigs());

    setStorage(updatedStorage);
    setAppConfigurations(updatedStorage.export());
  };

  const persistAppConfigurations = () => {
    storage.update(appConfigurations);
  };

  const updateAppConfigurations = (newConfigurations) => {
    if (newConfigurations === null) {
      setAppConfigurations(null);
    } else {
      setAppConfigurations({
        ...appConfigurations,
        ...newConfigurations,
      });
    }
  };

  return [appConfigurations, updateAppConfigurations, persistAppConfigurations];
}
